import { Field, TextInput, TextArea, SelectInput } from "./formFields";

const urgencyOptions = [
  "Standard \u2014 normal planning cycle",
  "Time-sensitive \u2014 tied to a fixed external date",
  "Urgent \u2014 needed immediately",
];

export default function RequestBasicsStep({ data, update }) {
  return (
    <div data-testid="request-basics-step">
      <h2 className="text-xl font-semibold text-gray-900 mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>
        Request Basics
      </h2>
      <p className="text-sm text-gray-500 mb-6">Tell us who's asking and why, before we get into specifics.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
        <Field label="Requestor name" required testId="request-field-reqName">
          <TextInput value={data.reqName} onChange={(v) => update("reqName", v)} placeholder="e.g. Neha Gupta" testId="request-input-reqName" />
        </Field>
        <Field label="Requestor role / team" required testId="request-field-reqRole">
          <TextInput value={data.reqRole} onChange={(v) => update("reqRole", v)} placeholder={"e.g. Microsoft GPS \u2014 Strategy Lead"} testId="request-input-reqRole" />
        </Field>
        <Field label="Sponsoring Microsoft stakeholder" hint="(if different)" testId="request-field-sponsor">
          <TextInput value={data.sponsor} onChange={(v) => update("sponsor", v)} placeholder="e.g. Justin Slade" testId="request-input-sponsor" />
        </Field>
        <Field label="Target date / deadline" required testId="request-field-targetDate">
          <TextInput type="date" value={data.targetDate} onChange={(v) => update("targetDate", v)} testId="request-input-targetDate" />
        </Field>
      </div>

      <Field label={"Business justification \u2014 what problem does this solve, and for whom?"} required testId="request-field-justification">
        <TextArea
          value={data.justification}
          onChange={(v) => update("justification", v)}
          placeholder="What's driving this request? What happens if it doesn't get built?"
          testId="request-input-justification"
        />
      </Field>

      <Field label="Urgency" required testId="request-field-urgency">
        <SelectInput value={data.urgency} onChange={(v) => update("urgency", v)} options={urgencyOptions} testId="request-input-urgency" />
      </Field>
    </div>
  );
}
